import { Button, Chip, styled } from '@mui/material';

export const DATE_NUMBER_CELL_SX = {
  fontSize: '0.875rem',
  color: '#615E6F',
  fontFamily: 'Neue Frutiger World',
} as const;

/**
 * A cell whose text navigates somewhere. It reads as plain cell text, not as a button:
 * MUI's button typography (0.75rem with wider tracking) would make the one clickable
 * column the odd one out in every row it appears in.
 */
export const CellLinkButton = styled(Button)({
  padding: 0,
  minWidth: 0,
  justifyContent: 'flex-start',
  font: 'inherit',
  letterSpacing: 'inherit',
  color: 'inherit',
  textTransform: 'none',

  '&:hover': {
    background: 'none',
  },
});

export const StatusChip = styled(Chip)<{ statuscolor?: string; statusbg?: string }>(
  ({ statuscolor, statusbg }) => ({
    padding: '0.25rem 0.75rem !important',
    height: 'auto',
    borderRadius: '0.75rem',
    backgroundColor: statusbg || '#8F8EA3',
    color: statuscolor || '#FEFEFE',
    border: 'none',
    justifyContent: 'center',

    '& .MuiChip-label': {
      fontFamily: 'Neue Frutiger World !important',
      fontSize: '0.875rem !important',
      fontStyle: 'normal !important',
      fontWeight: '500 !important',
      lineHeight: '130% !important',
      textTransform: 'lowercase !important',
      color: `${statuscolor || '#FEFEFE'} !important`,
      padding: '0 !important',

      '&::first-letter': {
        textTransform: 'uppercase',
      },
    },
  }),
);
